/* eslint-disable jsx-a11y/alt-text */
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { IonButton, IonCard } from '@ionic/react';
import { usePageView } from '../support/tracking/usePageView';
import { Page } from '../components/page/Page';
import { AffiliateLinkState } from '../affiliates/AffiliateLinkState';
import { HistoryViewModel } from '../app/HistoryViewModel';

export const MarketplacePage: React.FC = () => {
    // TODO: event name
    usePageView('Marketplace');
    const history = useInstance(HistoryViewModel);
    const affiliateLinkState = useInstance(AffiliateLinkState);
    const affiliates = useInstance(AffiliateLinkState).getAffiliateLinks();

    return (
        <Page title="Pilot Perks" onBack={() => history.back('/')}>
            {affiliates.map(a => (
                <IonCard>
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: 10,  }}>
                        <img height={200} src={a.heroImageUrl} style={{ borderRadius: 5 }}  />
                        <IonButton
                            fill="outline"
                            onClick={() => affiliateLinkState.affiliateLinkClicked(a, { source: 'marketplace' })}
                        >{a.offer}</IonButton>
                    </div>
                </IonCard>
            ))}
        </Page>
    );
};
